import { render, staticRenderFns } from "./pageElementText.vue?vue&type=template&id=5ec333cd&"
import script from "./pageElementText.vue?vue&type=script&lang=js&"
export * from "./pageElementText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports